import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EnvironmentService } from "@app/core/environment/environment.service";
import { EMPTY } from "rxjs";
import { catchError, retry, shareReplay } from "rxjs/operators";
import { normalizePath } from "../utils";
import { SdkAnalyticsService } from "../services/sdk-analytics/sdk-analytics.service";
import { Router } from "@angular/router";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../core/environment/environment.service";
import * as i3 from "../services/sdk-analytics/sdk-analytics.service";
import * as i4 from "@angular/router";
var FeatureToggleService = /** @class */ (function () {
    function FeatureToggleService(http, environmentService, _sdkAnalyticsService, router) {
        this.http = http;
        this.environmentService = environmentService;
        this._sdkAnalyticsService = _sdkAnalyticsService;
        this.router = router;
        this.API_CACHE = 1;
        this.API_ATTEMPTS = 3;
        var apiUrl = environmentService.envModel.appSettings.fm6ApiUrlFeatureToggle;
        this.iServicesUri = this.environmentService.envModel.iServicesUri;
        this.baseUrl = apiUrl + "/user/features/iservices";
    }
    FeatureToggleService.prototype.fetchLoggedUserFeature = function (jwt) {
        var headers = new HttpHeaders({ Authorization: "Bearer " + jwt });
        return this.http.get(this.baseUrl, { headers: headers }).pipe(retry(this.API_ATTEMPTS), catchError(function () {
            return EMPTY;
        }), shareReplay(this.API_CACHE));
    };
    FeatureToggleService.prototype.goToiServices = function (url) {
        url = url ? document.location.origin + url : "";
        if (url.includes("localhost")) {
            url = url.replace("/iservices", "");
            url = url.replace("4200", "3000");
        }
        var token = localStorage.getItem("token");
        var authUser = JSON.parse(localStorage.getItem("authUser"));
        var iServicesURl = (url || this.iServicesUri) + "?token=" + token + "&idConexao=" + authUser.idConexao + "&username=" + authUser.name;
        if (this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('screen_view', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: 'iservices-redirect'
            });
        }
        window.open(iServicesURl, "_blank");
    };
    FeatureToggleService.prototype.getiServicesLinks = function (param) {
        var iServicesURL = "/iservices" + param;
        return iServicesURL;
    };
    FeatureToggleService.ngInjectableDef = i0.defineInjectable({ factory: function FeatureToggleService_Factory() { return new FeatureToggleService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService), i0.inject(i3.SdkAnalyticsService), i0.inject(i4.Router)); }, token: FeatureToggleService, providedIn: "root" });
    return FeatureToggleService;
}());
export { FeatureToggleService };
